import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@app/shared';
import { CareerOportunitiesComponent } from './career-oportunities.component';

@NgModule({
  declarations: [CareerOportunitiesComponent],
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [CareerOportunitiesComponent],
})
export class CareerOportunitiesModule {}
